const notifications = {
  search_contacts: 'Téléphone / Courriel',
  report_type: 'Type de rapport',
  failed_payments_report: 'Rapport des paiements échoués',
  paid_payments_report: 'Rapport des paiements payés',
};

export default notifications;
